import styled from 'styled-components';
import getColour, { ValidHex } from '@lendi-ui/commons/colours';
import { mb, px, py } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';
import { Body, body, Link, link } from '@lendi-ui/typography';

import { materialCard } from '../../style';

interface ButtonProps {
  color?: ValidHex;
}

export const SearchListContainer = styled.div`
  ${mb('md')};
  ${materialCard};
`;

export const SearchListHeader = styled.div`
  text-align: center;
  border-top-left-radius: ${select('borderRadius')};
  border-top-right-radius: ${select('borderRadius')};
  position: relative;
  ${body({ size: 'xs' })};
  ${py('xxs')};
  ${px('sm')};
  color: ${() => getColour('text', 'subtle')};
  background-color: ${() => getColour('background', 'container')};
  border-bottom: solid 1px;
  border-color: ${() => getColour('border', 'container')};
`;

export const SearchListItem = styled.div`
  ${px('xs')};
  ${py('sm')};
  border-bottom: solid 1px;
  border-color: ${() => getColour('border', 'container')};
  &:hover {
    background-color: ${() => getColour('shade', 50)};
  }
  display: grid;
  grid-template-columns: 1fr 80px;
  grid-template-rows: auto;
  grid-template-areas: 'name button' 'abn button';
`;

export const Name = styled(Body)`
  grid-area: name;
  font-weight: bold;
  ${body({ size: 'md' })};
`;

export const ABN = styled(Body)`
  grid-area: abn;
  ${body({ size: 'md' })};
`;

export const SelectButton = styled(Link)`
  grid-area: button;
  color: ${() => getColour('interaction', 'main')};
  align-self: start;
`;

export const Paginator = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: ${select('borderRadius')};
  border-bottom-right-radius: ${select('borderRadius')};
  position: relative;
`;

export const PaginatorButton = styled.button<ButtonProps>`
  ${link({ size: 'sm' }) as {}};
  color: ${(props) => props.color || getColour('interaction', 'subtle')};
  background: none;
  border: none;
  cursor: pointer;
  font-weight: 700;
  letter-spacing: 1px;
  text-decoration: none;
  text-transform: uppercase;

  &:hover,
  &:focus,
  &:active {
    border: none;
    outline: none;
    text-decoration: none;
  }
`;
